<script setup>
import { useModals } from "@/composables/useModals";

const { triggerQrScan } = useModals();

const props = defineProps({
	typeBtn: {
		type: String,
		default: 'upload' 
	}
})

</script>
<template>
	<button @click="triggerQrScan(props.typeBtn)" class="btn"><slot></slot></button>
</template>
<style lang="scss" scoped></style>
